import script from "./PostNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PostNew.vue?vue&type=script&setup=true&lang=js"

import "./PostNew.vue?vue&type=style&index=0&id=26a077c8&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a077c8"]])

export default __exports__